module.exports = "/build/web/svg/sponsor/vdk-wit.8f87a9cc60f1009c15e189a93704a402.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/vdk-wit.svg
// module id = 223
// module chunks = 24